module.exports = __webpack_public_path__ + "img/warning_icon.4ac02331.svg";